import { render, staticRenderFns } from "./StatsAsp.vue?vue&type=template&id=56614476&"
import script from "./StatsAsp.vue?vue&type=script&lang=js&"
export * from "./StatsAsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56614476')) {
      api.createRecord('56614476', component.options)
    } else {
      api.reload('56614476', component.options)
    }
    module.hot.accept("./StatsAsp.vue?vue&type=template&id=56614476&", function () {
      api.rerender('56614476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/StatsAsp.vue"
export default component.exports